import React from 'react';
import { Sparkle, TrendUp, TrendDown } from '@phosphor-icons/react';

const TREND_COLORS = { bullish: '#00FF66', bearish: '#FF3366', neutral: '#FBBF24' };
const RECOMMENDATION_COLORS = { buy: '#00FF66', sell: '#FF3366', hold: '#FBBF24' };

const trendIcon = (trend, color) => {
  if (trend === 'bullish') return <TrendUp size={20} weight="bold" style={{ color }} />;
  if (trend === 'bearish') return <TrendDown size={20} weight="bold" style={{ color }} />;
  return null;
};

export default function PatternResult({ pattern }) {
  const trendColor = TREND_COLORS[pattern.trend] || TREND_COLORS.neutral;
  const recColor = RECOMMENDATION_COLORS[pattern.recommendation] || RECOMMENDATION_COLORS.hold;

  return (
    <div className="bg-[#12141A] border border-[#A855F7]/30 p-6" data-testid="pattern-result">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Sparkle size={24} weight="duotone" className="text-[#A855F7]" />
          <h3 className="text-xl font-heading font-bold text-white">AI Pattern Analysis</h3>
        </div>
        <div className="text-xs font-mono text-[#94A3B8]">
          Confidence: <span className="text-white">{pattern.confidence}%</span>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Cell label="Pattern">
          <div className="text-lg font-heading font-bold text-white">{pattern.pattern}</div>
        </Cell>
        <Cell label="Trend">
          <div className="flex items-center gap-1">
            {trendIcon(pattern.trend, trendColor)}
            <span className="text-lg font-mono uppercase" style={{ color: trendColor }}>
              {pattern.trend}
            </span>
          </div>
        </Cell>
        <Cell label="Support / Resistance">
          <div className="font-mono text-sm">
            <span className="text-[#00FF66]">₹{pattern.support}</span>
            {' / '}
            <span className="text-[#FF3366]">₹{pattern.resistance}</span>
          </div>
        </Cell>
        <Cell label="Recommendation">
          <div className="text-lg font-heading font-bold uppercase" style={{ color: recColor }}>
            {pattern.recommendation}
          </div>
        </Cell>
      </div>

      <div className="mt-4 pt-4 border-t border-white/5 text-sm text-[#94A3B8] italic">
        {pattern.rationale}
      </div>
    </div>
  );
}

function Cell({ label, children }) {
  return (
    <div>
      <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#94A3B8] mb-1">{label}</div>
      {children}
    </div>
  );
}
